import React, { useEffect } from 'react'
import store from '../../store'
import { ActionType } from '../../store/home/action'

function AppLoading(): JSX.Element {
  useEffect(() => {
    store.dispatch({
      type: ActionType.SET_IS_LOADING,
      payload: { isLoading: true }
    })
    return () => {
      store.dispatch({
        type: ActionType.SET_IS_LOADING,
        payload: { isLoading: false }
      })
    }
  }, [])
  return <></>
}

export default AppLoading
